import { alpha, Theme, ThemeOptions } from '@mui/material';

import { capitalDesignTokens } from '../../capital_design_tokens';

export const getListItemDisabledStyles = (theme: Theme) => ({
  color: theme.palette.text.disabled,
  backgroundColor: theme.palette.action.disabledBackground,
  opacity: 1,
  '& .MuiListItemIcon-root, & .MuiListItemText-root': {
    color: theme.palette.text.disabled
  }
});

export const getListItemInteractiveStyles = (theme: Theme) => ({
  '&.Mui-disabled': {
    ...getListItemDisabledStyles(theme)
  },

  '&.Mui-focusVisible': {
    // Fixes issue where focus styles were also applied to outer menu item when inner element is focused
    backgroundColor: 'inherit',
    outline: 'inherit'
  },

  '&:hover, &:focus-visible': {
    backgroundColor: theme.palette.action.hover
  },

  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    color: theme.palette.text.primary,
    '&:hover, &.Mui-focusVisible': {
      backgroundColor: alpha(theme.palette.primary.main, 0.2),
      color: theme.palette.text.primary
    }
  },

  ':focus-visible': {
    outline: `2px solid ${theme.palette.primary.main}`,
    borderRadius: capitalDesignTokens.foundations.units.unitHalf,
    outlineOffset: '-2px'
  }
});

export const MuiListItemButton: ThemeOptions['components']['MuiListItemButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...getListItemInteractiveStyles(theme)
    })
  }
};
